import { useTranslation } from 'react-i18next'

import type { SelectOption } from '@/components/Select/Select'
import { AsyncSelect } from '@/components/common/AsyncSelect'
import { coursesQueryOptions } from '@/queries/coursesQueryOptions'
import type { FormFieldType } from '@/types/form-field-type'

const PreferredCoursesSelect = (
  props: FormFieldType<SelectOption<string>[]>
) => {
  const { t } = useTranslation('rooms')

  return (
    <AsyncSelect
      {...props}
      multiple
      placeholder={t('placeholder.select-course')}
      queryOptions={coursesQueryOptions}
    />
  )
}

export default PreferredCoursesSelect
